import { useTheme } from 'next-themes';
import { Toaster as HotToaster, ToastBar, toast as hotToast } from 'react-hot-toast';
import { X } from 'lucide-react';

/**
 * Minimal Toast Notifications
 *
 * Compact, bottom-anchored design with close button.
 * Constrained to a small area so notifications never take over the screen.
 */



// TODO: need to discuss this with VIVEK KUMAR if we need this changes by VKATHI ?.

export function Toaster() {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <HotToaster
      position="bottom-right"
      gutter={6}
      containerStyle={{
        bottom: 16,
        right: 16,
        maxHeight: '180px',
        overflow: 'hidden',
      }}
      toastOptions={{
        duration: 5000,
        style: {
          padding: '8px 12px',
          fontSize: '12px',
          fontWeight: 500,
          maxWidth: '320px',
          borderRadius: '8px',
          background: isDark ? '#1a1a1a' : '#ffffff',
          color: isDark ? '#e5e5e5' : '#171717',
          border: `1px solid ${isDark ? '#2a2a2a' : '#e5e5e5'}`,
          boxShadow: isDark
            ? '0 2px 8px rgba(0, 0, 0, 0.4)'
            : '0 2px 8px rgba(0, 0, 0, 0.08)',
        },
      }}
    >
      {(t) => (
        <ToastBar toast={t} style={{ padding: 0, ...t.style }}>
          {({ icon, message }) => (
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', width: '100%' }}>
              {icon}
              <span style={{ flex: 1, minWidth: 0 }}>{message}</span>
              <button
                type="button"
                onClick={() => hotToast.dismiss(t.id)}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '2px',
                  color: isDark ? '#666' : '#999',
                  flexShrink: 0,
                  display: 'flex',
                  alignItems: 'center',
                  borderRadius: '4px',
                }}
                onMouseEnter={(e) => { e.currentTarget.style.color = isDark ? '#ccc' : '#333'; }}
                onMouseLeave={(e) => { e.currentTarget.style.color = isDark ? '#666' : '#999'; }}
              >
                <X size={14} />
              </button>
            </div>
          )}
        </ToastBar>
      )}
    </HotToaster>
  );
}
